import { FC } from "react";
import { AlertTriangle } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogDescription, DialogFooter, DialogHeader, DialogTitle } from "@/components/ui/dialog";
interface DeleteConfirmationModalProps {
  isOpen: boolean;
  onConfirm: () => void;
  onCancel: () => void;
  text: string;
}
export const DeleteConfirmationModal: FC<DeleteConfirmationModalProps> = ({
  isOpen,
  onConfirm,
  onCancel,
  text
}) => {
  return <Dialog open={isOpen} onOpenChange={open => !open && onCancel()} data-sentry-element="Dialog" data-sentry-component="DeleteConfirmationModal" data-sentry-source-file="index.tsx">
            <DialogContent className="sm:max-w-md bg-slate-900 border border-slate-700" data-sentry-element="DialogContent" data-sentry-source-file="index.tsx">
                <DialogHeader className="flex flex-col items-center gap-1" data-sentry-element="DialogHeader" data-sentry-source-file="index.tsx">
                    <div className="bg-red-900/30 p-3 rounded-full mb-2">
                        <AlertTriangle className="h-6 w-6 text-red-500" data-sentry-element="AlertTriangle" data-sentry-source-file="index.tsx" />
                    </div>
                    <DialogTitle className="text-xl text-slate-100" data-sentry-element="DialogTitle" data-sentry-source-file="index.tsx">
                        Confirm Deletion
                    </DialogTitle>
                    <DialogDescription className="text-slate-300 pt-2" data-sentry-element="DialogDescription" data-sentry-source-file="index.tsx">
                        Are you sure you want to delete this {text}?
                    </DialogDescription>
                </DialogHeader>

                <DialogFooter className="sm:justify-center gap-3 mt-4" data-sentry-element="DialogFooter" data-sentry-source-file="index.tsx">
                    <Button onClick={onConfirm} className="bg-slate-700 hover:bg-slate-600 text-white" data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        Confirm
                    </Button>
                    <Button variant="destructive" onClick={onCancel} className="bg-red-700 hover:bg-red-600" data-sentry-element="Button" data-sentry-source-file="index.tsx">
                        Cancel
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>;
};